import { RestoreRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import {
  CASSubtype,
  useSubtypesTableContext,
} from '../../../../SubtypesTableContext'
import { Permission } from '@cims-online/shared'
import { useRestoreCasSubtypeMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleRestoreNotification } from 'hooks/notificationHandler'

export function useRestoreOptions(): RestoreRowActionOptions<CASSubtype> {
  const { refetch } = useSubtypesTableContext()
  const [restore] = useRestoreCasSubtypeMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      restoreCASSubtype: {
        subtype: { name },
      },
    }) => simpleRestoreNotification(name),
  })
  return {
    permission: Permission.RemoveRestoreCASSubtype,
    default: 'active',
    metadata: ({ deleted, deletedDate, deletedUser }) => ({
      removed: deleted,
      removedBy: deletedUser,
      removedDate: deletedDate,
    }),
    onRestore: async ({ id }) => {
      await restore({ variables: { id } })
      refetch()
    },
  }
}
